"use client";
import useAmplitudeInit from "./amplitude";

export function AmpltideProvider({ children }) {
  useAmplitudeInit();

  return children;
}
